// extracted by mini-css-extract-plugin
export default {"rating":"iA-z","numberOfStars":"jA-z","count":"kA-z","barGraphSpacing":"lA-z","barGraph":"mA-z"};